export type StatusBadgeSize = 'caption' | 'small';

export type StatusBadgeTone =
  | 'pending'
  | 'accepted'
  | 'declined'
  | 'info'
  | 'shipped'
  | 'warning'
  | 'neutral';

const TONE_CLASSES: Record<StatusBadgeTone, string> = {
  pending: 'bg-warning-100 text-warning-700',
  accepted: 'bg-success-100 text-success-700',
  declined: 'bg-error-100 text-error-600',
  info: 'bg-neut-100 text-neut-600',
  shipped: 'bg-prim-100 text-prim-700',
  warning: 'bg-warning-100 text-warning-600',
  neutral: 'bg-neut-100 text-neut-400',
};

export function statusBadgeClasses(
  tone: StatusBadgeTone,
  size: StatusBadgeSize = 'caption'
): string {
  const sizeClass = size === 'caption' ? 'text-xs' : 'text-sm';
  return `px-2 py-1 ${sizeClass} font-medium rounded-full ${TONE_CLASSES[tone]}`;
}
